import { render, staticRenderFns } from "./SimpleHtmlEditor.vue?vue&type=template&id=1f5a02af&scoped=true&"
import script from "./SimpleHtmlEditor.vue?vue&type=script&lang=js&"
export * from "./SimpleHtmlEditor.vue?vue&type=script&lang=js&"
import style0 from "./SimpleHtmlEditor.vue?vue&type=style&index=0&id=1f5a02af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5a02af",
  null
  
)

export default component.exports